import { CategoryAttributes } from 'models/@types';

const attributes: CategoryAttributes[] = [
  {
    category: 'character',
    attributes: [
      { attribute: 'GENDER', values: ['Male', 'Female'] },
      { attribute: 'EYES', values: ['Blue', 'Green', 'Brown', 'Gold'] },
      { attribute: 'HAIR', values: ['Black', 'Blonde', 'Red', 'Silver'] },
    ],
  },
  {
    category: 'companion',
    attributes: [
      { attribute: 'TYPE', values: ['Dragon', 'Phoenix', 'Wolf', 'Owl'] },
      { attribute: 'RARITY', values: ['Common', 'Rare', 'Epic', 'Legendary'] },
    ],
  },
  {
    category: 'land',
    attributes: [
      {
        attribute: 'REGION',
        values: ['Elysian Fields', 'Mystic Alpines', 'Enchanted Forest', 'Forest of Whimsy'],
      },
    ],
  },
  {
    category: 'item',
    attributes: [
      { attribute: 'TYPE', values: ['Weapon', 'Armor', 'Accessory'] },
      { attribute: 'RARITY', values: ['Common', 'Uncommon', 'Rare', 'Epic', 'Legendary'] },
    ],
  },
  {
    category: 'resource',
    attributes: [{ attribute: 'TYPE', values: ['Ore', 'Wood', 'Crystal', 'Herb'] }],
  },
  {
    category: 'structure',
    attributes: [{ attribute: 'TYPE', values: ['Tower', 'Shrine', 'Portal', 'Workshop'] }],
  },
];

export default attributes;
